<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        เพิ่มผู้ให้บริการ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> เพิ่มผู้ให้บริการ
          </a>
        </li>
        <li class="active">เพิ่มผู้ให้บริการ</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-smrs-12">
            <div class="box">
              <div class="box-header">
                <el-form
                  size="mini"
                  :label-position="label_position"
                  label-width="150px"
                  :model="ruleForm"
                  ref="ruleForm"
                >
                  <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                      <el-form-item label="ชื่อ" required>
                        <el-input clearable v-model="ruleForm.first_name" maxlength="50" placeholder="4 - 50 ตัวอักษร" ></el-input>
                      </el-form-item>
                      <el-form-item label="นามสกุล" required>
                        <el-input clearable v-model="ruleForm.last_name"  maxlength="50" placeholder="4 - 50 ตัวอักษร" ></el-input>
                      </el-form-item>
                      <el-form-item label="เบอร์โทรศัพท์" required>
                        <el-input v-model="ruleForm.phone_number" @keypress.native="isNumberKey" maxlength="10" placeholder="ตัวเลข 10 หลัก" show-word-limit clearable></el-input>
                      </el-form-item>
                      <el-form-item label="ชื่อผู้ใช้งาน (Username)" required>
                        <el-input clearable v-model="ruleForm.username" autocomplete="off" maxlength="20" placeholder="8 - 20 ตัวอักษร"  @keypress.native="checkCharater"></el-input>
                      </el-form-item>
                      <el-form-item label="อีเมล (E-mail)" required>
                        <el-input show-email v-model="ruleForm.email" @keypress.native="checkCharater" maxlength="50" placeholder="ไม่เกิน 50 ตัวอักษร" ></el-input>
                      </el-form-item>
                        <el-form-item label="ผู้ให้บริการ" required>
                          <el-select
                            v-model="ruleForm.company_provider_id"
                            placeholder="โปรดเลือกชื่อผู้ให้บริการ"
                            @change="selectList"
                          >
                            <el-option v-for="item in this.operators" 
                            :label="item.provider_name" 
                            :key="item.id"  
                            :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      <el-form-item label="ชื่อหน่วยงาน (Departments)" required>
                        <el-input v-model="ruleForm.departments" maxlength="100" placeholder="ไม่เกิน 100 ตัวอักษร"></el-input>
                      </el-form-item>
                    </div>
                  </div>

                  <el-form-item>
                    <div class="layout_select_privilege">
                      <h2>สิทธิการจัดการ</h2>
                    </div>
                    <div class="row" v-if="ruleForm.checkType == 'mobile'">
                      <div class="col-sm-4">
                        <label
                          for="จัดการข้อมูลโทรศัพท์เคลื่อนที่"
                        >เมนูจัดการข้อมูลรายการส่งเสริมการขายโทรศัพท์เคลื่อนที่</label>
                      </div>
                      <div class="col-sm-8">
                        <el-checkbox-group v-model="ruleForm.role_permission.Manage_mobile">
                          <el-checkbox style="width:165px;" label="add">เพิ่มรายการส่งเสริมการขาย</el-checkbox>
                          <el-checkbox style="width:165px;" label="edit">แก้ไขรายการส่งเสริมการขาย</el-checkbox>
                          <el-checkbox style="width:165px;" label="delete">ลบรายการส่งเสริมการขาย</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="row" v-if="ruleForm.checkType == 'broadband'">
                      <div class="col-sm-4">
                        <label
                          for="จัดการข้อมูลอินเทอร์เน็ตประจำที่"
                        >เมนูจัดการข้อมูลรายการส่งเสริมการขายอินเทอร์เน็ตความเร็วสูงประจำที่</label>
                      </div>
                      <div class="col-sm-8">
                        <el-checkbox-group v-model="ruleForm.role_permission.Manage_internet">
                          <el-checkbox style="width:165px;" label="add">เพิ่มรายการส่งเสริมการขาย</el-checkbox>
                          <el-checkbox style="width:165px;" label="edit">แก้ไขรายการส่งเสริมการขาย</el-checkbox>
                          <el-checkbox style="width:165px;" label="delete">ลบรายการส่งเสริมการขาย</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <label
                          for="จัดการข้อมูลอินเทอร์เน็ตประจำที่"
                        >เมนูนำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล</label>
                      </div>
                      <div class="col-sm-8">
                        <el-checkbox-group v-model="ruleForm.role_permission.Upload_save">
                          <el-checkbox style="width:310px;" label="true">อนุญาต</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <label
                          for="จัดการข้อมูลอินเทอร์เน็ตประจำที่"
                        >รายงานจำนวนผู้เข้าชมข้อมูลรายการส่งเสริมการขายจำแนกตามการให้บริการ</label>
                      </div>
                      <div class="col-sm-8">
                        <el-checkbox-group v-model="ruleForm.role_permission.Reportview_promotion">
                          <el-checkbox style="width:165px;" label="true">อนุญาต</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <label>รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ</label>
                      </div>
                      <div class="col-sm-8">
                        <el-checkbox-group v-model="ruleForm.role_permission.User_behavior">
                          <el-checkbox style="width:165px;" label="true">อนุญาต</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <label>เมนูแจ้งปัญหาการใช้งาน</label>
                      </div>
                      <div class="col-sm-8">
                        <el-checkbox-group v-model="ruleForm.role_permission.Contact_admin">
                          <el-checkbox style="width:165px;" label="true">อนุญาต</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </el-form-item>
                  <div class="box-footer">
                    <el-button type="secondary" style="float: left" @click="back">ยกเลิก</el-button>
                    <el-button type="primary" style="float: right" @click="submitForm('ruleForm')">บันทึก</el-button>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import {mapState,mapActions} from "vuex"
import Cookie from "cookies-js";
export default {
  data() {
    return {
      label_position: "top",
      ruleForm: {
        role_permission: {
          Manage_mobile: ['Manage_mobile'],
          Manage_internet: ['Manage_internet'],
          Upload_save: ['Upload_save'],
          Reportview_promotion: ['Reportview_promotion'],
          User_behavior:['User_behavior'],
          Contact_admin: ['Contact_admin']
        },
        firstname: "",
        lastname: "",
        phoneNumber: "",
        username: "",
        repass:"",
        company: "",
        company_provider_id: "",
        admin_id: "",
        departments: "",
        checkType : "broadband"
      }
    };
  },
  beforeCreate(){
    this.$store.dispatch('Manage_operator/getCompanyList')
  },
  mounted(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    this.ruleForm.admin_id = json_cookie.admin_id

  },
  computed: {
    ...mapState({
      operators: store => store.Manage_operator.select_lists,
    })
  },
  methods: {
    ...mapActions({
      insert: "Manage_admin/add_admin"
    }),
    selectList(){
      for(let item of this.operators){
        if(item.id == this.ruleForm.company_provider_id){
          this.ruleForm.Manage_internet = ["Manage_internet"]
          this.ruleForm.Manage_mobile = ["Manage_mobile"]
          this.ruleForm.checkType = item.provider_type
        }
      }
    },
    submitForm() {
      return this.insert(this.ruleForm)
      if(this.ruleForm.firstname.length<4){
        this.$confirm("กรุณากรอกชื่อ ความยาว 4 - 50 ตัวอักษร", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else if(this.ruleForm.last_name.length<4){
        this.$confirm("กรุณากรอกนามสกุล ความยาว 4 - 50 ตัวอักษร", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else if (this.ruleForm.phone_number.length !== 10){
        this.$confirm("กรุณากรอกหมายเลขโทรศัพท์ เป็นตัวเลข 10 หลัก", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else if (this.ruleForm.username.length<8){
        this.$confirm("กรุณากรอกชื่อผู้ใช้งาน ความยาว 8 - 20 ตัวอักษร", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else if (!this.ruleForm.email){
        this.$confirm("กรุณากรอกอีเมล", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      } else {
        this.ruleForm.permission = this.ruleForm.role_permission
        this.insert(this.ruleForm)
      }
    },
    back(){
      this.$router.push({name : 'Manage_operator'})
    }
  }
};
</script>
